import type { BalanceType } from '../../../../../api/fetchers/userInfo/types';
import { GameCommunicationBetSender } from '../../../../../controllers/gameCommunication/senders/GameCommunicationBetSender';
import type { CoreDispatch } from '../../../../../store/CoreStore';
import { pushAutoplayBet } from '../../../../../store/slices/bets/slice';
import type { BetType } from '../../../../../store/slices/bets/types';
import { popupActions } from '../../../../../store/slices/popup/slice';
import { PopupType } from '../../../../popup/types';

const betSender = new GameCommunicationBetSender();

export function placeAutoplayBet(
  isInProgress: boolean,
  savedBet: BetType | null,
  disabledBets: string[],
  freeChipValue: number,
  freeChipBalance: number,
  dispatch: CoreDispatch,
  balance?: BalanceType,
  digitsNumber?: number
): void {
  if (isInProgress) {
    const deductibleBalance = (balance?.amount ?? 0) + (balance?.bonus ?? 0);
    const newBet: BetType = { betSpots: {} };

    for (const betId in savedBet!.betSpots) {
      if (savedBet!.betSpots[betId] && savedBet!.betSpots[betId].value > 0 && !disabledBets.includes(betId)) {
        newBet.betSpots[betId] = savedBet!.betSpots[betId];
      }
    }

    dispatch(
      pushAutoplayBet({
        bet: newBet,
        balance: deductibleBalance,
        decimals: digitsNumber ?? 2,
        freeChipValue,
        freeChipBalance,
      })
    );
    betSender.dispatch();
    dispatch(popupActions.dismissPopup(PopupType.AutoplayModified));
  }
}
